function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.18,
  d: "M132.346 70.1139C129.96 74.6099 125.64 78.1196 124.441 83.0696C123.925 85.2049 124.044 87.4529 123.778 89.6289C122.839 97.284 117.101 103.665 110.261 107.281C109.973 107.438 109.681 107.594 109.393 107.726C104.901 109.917 100.04 111.113 95.0811 111.862C92.0665 112.309 89.0175 112.594 86.0029 112.835C73.4164 113.829 60.8123 114.191 48.1903 113.922C42.0923 113.796 35.8721 113.508 30.1371 111.483C29.8429 111.383 29.5517 111.273 29.2606 111.17C24.6088 109.363 20.4766 106.395 16.8203 102.998L16.6512 102.841C11.198 97.7443 6.68704 91.5701 3.7726 84.7102C-0.385927 74.8929 -1.10842 63.9589 1.72216 53.6797C3.44703 47.5681 6.45851 41.7383 6.92495 35.4076C7.27556 30.6486 6.15486 25.827 6.8999 21.1149C8.36495 11.7472 17.0613 4.85606 26.246 2.5517C35.4307 0.247343 45.0943 1.54041 54.4731 2.86479C59.053 3.51916 64.4154 5.26621 68.9514 3.86669C74.5267 2.15094 79.213 0.0125237 85.2297 0C87.6839 0 90.1851 0.256736 92.4296 1.25237C95.1531 2.44212 97.3131 4.60246 99.5263 6.57494C105.703 12.1104 112.746 16.5939 119.057 21.9791C125.368 27.3643 131.091 33.9048 133.413 41.8667C134.55 45.7584 134.828 49.8505 134.95 53.902C135.123 59.4374 134.944 65.2234 132.346 70.1139Z",
  fill: "#00B0F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M100.399 36.8728H36.3788C33.6298 36.8728 31.4014 39.1016 31.4014 41.851V84.5881C31.4014 87.3375 33.6298 89.5663 36.3788 89.5663H100.399C103.148 89.5663 105.377 87.3375 105.377 84.5881V41.851C105.377 39.1016 103.148 36.8728 100.399 36.8728Z",
  fill: "#00B0F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35.355 68.7142C34.5943 69.259 33.5863 69.3404 32.788 69.8131C32.0299 70.3354 31.4594 71.0871 31.1602 71.9578C30.4152 73.7957 30.3056 75.8245 30.315 77.8064C30.315 79.901 30.2837 82.2335 30.7658 84.2811C30.8972 84.8447 31.7738 87.3213 32.6252 87.2273C33.1637 87.1679 33.627 77.2428 33.8273 75.956C34.0277 74.6692 34.2531 73.4513 34.5192 72.1989C34.6538 71.579 34.8604 69.0711 35.355 68.7142Z",
  fill: "url(#paint0_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M100.862 40.6362H35.918V84.729H100.862V40.6362Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M78.4803 85.9626C78.5241 85.0233 78.7182 83.9306 78.0702 83.245C77.7482 82.9663 77.3836 82.7411 76.9902 82.5781C76.3346 82.2158 75.7752 81.702 75.3586 81.0794C74.942 80.4569 74.6803 79.7437 74.5954 78.9994C74.514 78.201 74.6424 77.3933 74.5954 76.5886C74.5234 74.948 73.7721 73.4139 72.8987 72.0206C72.0253 70.6273 71.0205 69.3155 70.313 67.8283C70.1659 67.5152 70.0657 67.0737 70.3506 66.889C70.6354 66.7043 71.0205 66.9642 71.2709 67.2021C73.985 69.9918 76.9902 72.5685 80.4337 74.3563C81.498 74.9104 82.6093 75.3863 83.5954 76.0689C85.2358 77.2085 86.4567 78.8867 87.352 80.6651C88.2473 82.4434 88.8201 84.3815 89.3993 86.3007C89.6121 87.0021 89.8219 87.766 89.5746 88.4548C89.511 88.6687 89.3734 88.8529 89.1864 88.9745C89.0067 89.0605 88.8095 89.1034 88.6104 89.0998C86.106 89.2375 83.5798 89.2407 81.0598 89.272C80.4337 89.272 79.6918 89.4191 79.1815 88.9777C78.4615 88.339 78.4396 86.8173 78.4803 85.9626Z",
  fill: "url(#paint1_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M45.8106 48.6326H43.876V66.3411H45.8106V48.6326Z",
  fill: "#00B0F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.1788 51.5287H47.2441V66.341H49.1788V51.5287Z",
  fill: "#00B0F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M52.4756 54.1712H50.541V66.338H52.4756V54.1712Z",
  fill: "#00B0F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M55.8438 51.5287H53.9092V66.341H55.8438V51.5287Z",
  fill: "#00B0F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M59.1436 57.4837H57.209V66.3379H59.1436V57.4837Z",
  fill: "#00B0F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M62.5118 51.5287H60.5771V66.341H62.5118V51.5287Z",
  fill: "#00B0F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M65.8077 55.9748H63.873V66.3412H65.8077V55.9748Z",
  fill: "#00B0F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M69.1768 53.9801H67.2422V66.341H69.1768V53.9801Z",
  fill: "#00B0F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M54.0911 71.9329H43.0156V72.5779H54.0911V71.9329Z",
  fill: "#00B0F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M54.0911 73.7237H43.0156V74.3686H54.0911V73.7237Z",
  fill: "#00B0F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M54.0911 75.5147H43.0156V76.1597H54.0911V75.5147Z",
  fill: "#00B0F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M54.0911 77.3088H43.0156V77.9538H54.0911V77.3088Z",
  fill: "#00B0F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M54.0911 79.0995H43.0156V79.7445H54.0911V79.0995Z",
  fill: "#00B0F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M82.8538 47.4679C80.9442 47.4621 79.1106 48.2152 77.7562 49.5616C76.4018 50.908 75.6377 52.7373 75.6319 54.6471C75.6261 56.557 76.3791 58.3909 77.7252 59.7455C79.0714 61.1001 80.9004 61.8644 82.8099 61.8702V59.3654H82.7818C81.8387 59.3661 80.9166 59.0869 80.1322 58.5633C79.3477 58.0398 78.7361 57.2952 78.3748 56.424C78.0135 55.5527 77.9186 54.5939 78.1022 53.6687C78.2858 52.7435 78.7397 51.8936 79.4063 51.2264C80.0729 50.5592 80.9225 50.1047 81.8474 49.9205C82.7723 49.7363 83.7311 49.8305 84.6024 50.1913C85.4738 50.5521 86.2186 51.1633 86.7426 51.9475C87.2666 52.7318 87.5463 53.6538 87.5463 54.597C87.5471 54.8255 87.5304 55.0537 87.4962 55.2796H90.0287C90.0475 55.0709 90.0569 54.8673 90.0569 54.6691C90.0569 53.7231 89.8706 52.7865 89.5085 51.9126C89.1465 51.0387 88.6159 50.2447 87.947 49.576C87.278 48.9073 86.484 48.3769 85.6101 48.0152C84.7362 47.6535 83.7996 47.4675 82.8538 47.4679Z",
  fill: "#00B0F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M111.831 24.1831H93.7626C92.4175 24.1831 91.3271 25.2736 91.3271 26.6189V44.2585C91.3271 45.6038 92.4175 46.6944 93.7626 46.6944H111.831C113.177 46.6944 114.267 45.6038 114.267 44.2585V26.6189C114.267 25.2736 113.177 24.1831 111.831 24.1831Z",
  fill: "url(#paint2_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M130.326 56.8762H112.257C110.912 56.8762 109.821 57.9668 109.821 59.3121V76.9517C109.821 78.297 110.912 79.3876 112.257 79.3876H130.326C131.671 79.3876 132.761 78.297 132.761 76.9517V59.3121C132.761 57.9668 131.671 56.8762 130.326 56.8762Z",
  fill: "url(#paint3_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M36.7827 8.26866H18.7138C17.3687 8.26866 16.2783 9.35923 16.2783 10.7045V28.3441C16.2783 29.6894 17.3687 30.78 18.7138 30.78H36.7827C38.1277 30.78 39.2181 29.6894 39.2181 28.3441V10.7045C39.2181 9.35923 38.1277 8.26866 36.7827 8.26866Z",
  fill: "url(#paint4_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.1088 42.0168H12.04C10.6949 42.0168 9.60449 43.1074 9.60449 44.4527V62.0923C9.60449 63.4376 10.6949 64.5282 12.04 64.5282H30.1088C31.4539 64.5282 32.5443 63.4376 32.5443 62.0923V44.4527C32.5443 43.1074 31.4539 42.0168 30.1088 42.0168Z",
  fill: "url(#paint5_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.4597 65.3205C34.9002 65.0647 35.4176 64.9747 35.9185 65.0669C36.1994 65.1708 36.4438 65.3544 36.6218 65.5952C36.7997 65.836 36.9035 66.1236 36.9203 66.4226C36.9481 67.016 36.8173 67.606 36.5415 68.1321C35.6274 70.1234 33.9808 71.6951 32.9634 73.6331C32.3306 74.8393 31.9534 76.1631 31.8552 77.5217C31.755 78.9369 31.802 80.6527 30.5749 81.3759C29.7046 81.8737 28.537 81.5356 27.8295 80.8217C27.122 80.1079 26.7808 79.1154 26.546 78.1417C25.9103 75.4293 25.8875 72.6093 26.4795 69.8871C27.0714 67.1648 28.263 64.609 29.9676 62.4056C30.2337 62.0644 30.6876 61.7043 31.0476 61.9454C31.1421 62.0315 31.2169 62.1371 31.2666 62.255C31.3163 62.3728 31.3399 62.5001 31.3356 62.6279C31.4107 63.3731 31.0476 66.1033 31.6893 66.5917C32.3937 67.1083 33.6928 65.6837 34.4597 65.3205Z",
  fill: "url(#paint6_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.3934 109.241L30.9224 105.014C30.6564 107.143 30.3965 109.272 30.1304 111.405V111.483C29.8362 111.383 29.5451 111.273 29.2539 111.17C24.6021 109.363 20.4699 106.395 16.8136 102.998L16.6445 102.842C17.4209 99.6543 18.3099 96.4889 19.199 93.3361C20.6014 88.3548 21.7033 82.6377 25.0466 78.6927C25.5882 78.0666 26.6118 78.2544 27.4007 78.5362C28.1896 78.818 29.0473 79.1624 29.855 79.4755C30.3761 79.6436 30.8401 79.9537 31.1948 80.3709C31.5298 80.8405 31.5673 81.4511 31.5892 82.0303C31.9536 91.1181 31.5536 100.22 30.3934 109.241Z",
  fill: "#00B0F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M110.261 107.281C109.973 107.438 109.682 107.594 109.394 107.726C104.902 109.917 100.04 111.113 95.0814 111.861C92.4049 106.113 89.5937 100.064 85.8654 94.989C84.6132 93.2857 83.336 91.8173 82.5596 89.8167C81.9774 88.3201 81.1416 86.3727 80.9944 84.7853C80.8536 83.0852 82.0869 82.2179 83.3172 81.2254C86.0932 78.983 89.3117 77.3527 92.7617 76.4414C93.0576 76.3264 93.3843 76.3187 93.6852 76.4195C93.944 76.5748 94.1468 76.8083 94.2643 77.0863L103.912 94.7134C106.044 98.6052 108.179 102.503 109.957 106.57C110.057 106.811 110.173 107.043 110.261 107.281Z",
  fill: "#00B0F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M76.8922 80.0138C76.1472 78.7019 76.6512 77.0645 76.5635 75.5554C76.4133 73.0506 74.6258 71.003 73.2452 68.9053C72.6411 67.9911 72.087 66.9547 72.1778 65.862C72.2091 65.4707 72.4094 65.0136 72.8039 64.976C72.9817 64.9719 73.1568 65.0198 73.3079 65.1137C73.9257 65.4318 74.483 65.8557 74.9545 66.3661C75.5023 66.9579 76.094 67.7343 76.8953 67.6404C77.2207 67.5693 77.5297 67.4376 77.8063 67.2522C78.8675 66.6823 80.0821 66.4913 81.2717 66.3129L82.7868 66.0781C84.0171 65.8871 85.2912 65.6992 86.4964 65.9591C87.186 66.1131 87.8368 66.4063 88.4091 66.8209C88.9813 67.2355 89.4628 67.7626 89.824 68.3699C90.8884 70.1796 90.7632 72.4401 91.3893 74.4345C91.6397 75.2172 92.0153 75.9624 92.2188 76.7576C92.4762 77.548 92.427 78.4063 92.0811 79.1622C91.599 80.0608 90.566 80.521 89.5767 80.7433C88.5875 80.9656 87.5357 81.0157 86.5934 81.4071C85.7952 81.7358 85.1096 82.2868 84.3583 82.7064C82.6021 83.6864 81.9353 82.8379 80.3388 82.1647C79.1023 81.645 77.6153 81.263 76.8922 80.0138Z",
  fill: "url(#paint7_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M79.8104 49.4279L79.5537 49.3621L83.8236 32.9467H91.5245V33.2128H84.0302L79.8104 49.4279Z",
  fill: "#00B0F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M109.624 70.909H94.204L86.8662 58.1787L87.0947 58.0441L94.3574 70.6429H109.624V70.909Z",
  fill: "#00B0F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M53.7838 51.5694L45.3222 25.0192H38.7139V24.753H45.5132L45.5445 24.8469L54.0373 51.488L53.7838 51.5694Z",
  fill: "#00B0F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M44.0291 61.6259L38.0093 54.9163H32.1084V54.6533H38.1282L44.2263 61.4506L44.0291 61.6259Z",
  fill: "#00B0F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M90.0284 55.2828C89.8761 57.0812 89.0543 58.7568 87.7255 59.978C86.3967 61.1991 84.6579 61.8767 82.8534 61.8765H82.8096V59.3718C83.952 59.3669 85.0547 58.9517 85.9166 58.2017C86.7786 57.4517 87.3423 56.4169 87.5052 55.2859L90.0284 55.2828Z",
  fill: "#00B0F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M90.0284 55.2828C89.8761 57.0812 89.0543 58.7568 87.7255 59.978C86.3967 61.1991 84.6579 61.8767 82.8534 61.8765H82.8096V59.3718C83.952 59.3669 85.0547 58.9517 85.9166 58.2017C86.7786 57.4517 87.3423 56.4169 87.5052 55.2859L90.0284 55.2828Z",
  fill: "url(#paint8_linear)"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 43.2499,
  y1: 80.189,
  x2: 13.6512,
  y2: 73.1403,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.99
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 4817.02,
  y1: 5687.26,
  x2: 6033.16,
  y2: 5687.26,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.99
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 107.477,
  y1: -50.0386,
  x2: 100.77,
  y2: 72.4336,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.02,
  stopColor: "white",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.14,
  stopColor: "white",
  stopOpacity: 0.06
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.32,
  stopColor: "white",
  stopOpacity: 0.39
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.68,
  stopColor: "white",
  stopOpacity: 0.68
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: 127.705,
  y1: -49.071,
  x2: 121.001,
  y2: 73.4011,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.02,
  stopColor: "white",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.32,
  stopColor: "white",
  stopOpacity: 0.39
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.68,
  stopColor: "white",
  stopOpacity: 0.68
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear",
  x1: 2394.45,
  y1: -4772.69,
  x2: 1921.43,
  y2: 4034.04,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.02,
  stopColor: "white",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.32,
  stopColor: "white",
  stopOpacity: 0.39
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.68,
  stopColor: "white",
  stopOpacity: 0.68
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear",
  x1: 1894.34,
  y1: -2234.33,
  x2: 1421.32,
  y2: 6572.4,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.02,
  stopColor: "white",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.32,
  stopColor: "white",
  stopOpacity: 0.39
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.68,
  stopColor: "white",
  stopOpacity: 0.68
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear",
  x1: 26.042,
  y1: 71.7233,
  x2: 36.9265,
  y2: 71.7233,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E5C5D5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.42,
  stopColor: "#EAD4D1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F0E9CB"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint7_linear",
  x1: 5117.5,
  y1: 4379.85,
  x2: 6422.89,
  y2: 4379.85,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E5C5D5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.42,
  stopColor: "#EAD4D1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F0E9CB"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint8_linear",
  x1: 2096.27,
  y1: 1146.94,
  x2: 2345.46,
  y2: 1524.07,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.02,
  stopColor: "white",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.32,
  stopColor: "white",
  stopOpacity: 0.39
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.68,
  stopColor: "white",
  stopOpacity: 0.68
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 135,
  height: 114,
  fill: "white"
})));

var SvgReportAnalysis = function SvgReportAnalysis(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 114,
    viewBox: "0 0 135 114",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReportAnalysis, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/report_analysis.d0dffad7.svg";
export { ForwardRef as ReactComponent };